import { Type, type Static } from '@sinclair/typebox';
import { reactionSchema } from '../../shared/reaction/reaction.schema';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { PostSchema } from './post.schema';

export const GetPostsListResponseSchema = ListResponseSchema(PostSchema);

export const GetPostResponseSchema = PostSchema;

export const CreatePostResponseSchema = PostSchema;

export const DeletePostResponseSchema = Type.Null();

export const GetPostReactionsListResponseSchema = ListResponseSchema(reactionSchema);

export const AddPostReactionResponseSchema = Type.Object({
  object: Type.Literal('PostReactionAdded'),
});

export const RemovePostReactionResponseSchema = Type.Object({
  object: Type.Literal('PostReactionRemoved'),
});
export const UpdatePostResponseSchema = PostSchema;

export type GetPostsListResponse = Static<typeof GetPostsListResponseSchema>;
export type GetPostResponse = Static<typeof GetPostResponseSchema>;
export type CreatePostResponse = Static<typeof CreatePostResponseSchema>;
export type UpdatePostResponse = Static<typeof UpdatePostResponseSchema>;
export type DeletePostResponse = Static<typeof DeletePostResponseSchema>;
export type GetPostReactionsListResponse = Static<typeof GetPostReactionsListResponseSchema>;
export type AddPostReactionResponse = Static<typeof AddPostReactionResponseSchema>;
export type RemovePostReactionResponse = Static<typeof RemovePostReactionResponseSchema>;
